import React, { useState } from 'react';
import {
  Button,
  Tooltip,
  Snackbar,
} from '@mui/material';
import ShareIcon from '@mui/icons-material/Share';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import XIcon from '@mui/icons-material/X';
import PopoverMenu from '../common/PopoverMenu';

interface ListShareMenuProps {
  text: string;
  url: string;
  hashtags?: string[];
  buttonText?: string;
  iconSize?: number;
  fontSize?: number;
}

const ListShareMenu: React.FC<ListShareMenuProps> = ({
  text,
  url,
  hashtags = [],
  buttonText,
  iconSize = 14,
  fontSize = 14,
}) => {
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const fullUrl = `${process.env.REACT_APP_FRONTEND_URL}${url}`;

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleCopyLink = () => {
    navigator.clipboard.writeText(fullUrl);
    setOpenSnackbar(true);
    handleClose();
  };

  const handleShareX = () => {
    const hashtagsParam = hashtags.length > 0 ? `&hashtags=${encodeURIComponent(hashtags.join(','))}` : '';
    const xShareUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(fullUrl)}${hashtagsParam}`;
    window.open(xShareUrl, '_blank');
    handleClose();
  };

  const menuOptions = [
    {
      icon: <XIcon />,
      label: 'Xでシェア',
      onClick: handleShareX
    },
    {
      icon: <ContentCopyIcon />,
      label: 'URLをコピー',
      onClick: handleCopyLink
    }
  ];

  return (
    <>
      <Tooltip title="シェア">
        <Button
          onClick={handleClick}
          size="small"
          startIcon={<ShareIcon sx={{ fontSize: `${iconSize}px`, color: 'primary.main' }} />}
          sx={{ 
            minWidth: 'auto',
            p: '2px 8px',
            fontSize: `${fontSize}px`,
            textTransform: 'none',
            lineHeight: '1',
            borderRadius: '4px',
            color: 'text.secondary',
            backgroundColor: 'action.hover',
            '&:hover': {
              backgroundColor: 'action.selected',
            }
          }}
        >
          {buttonText || '共有'}
        </Button>
      </Tooltip>

      <PopoverMenu
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        title="共有オプション"
        options={menuOptions}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      />

      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={() => setOpenSnackbar(false)}
        message="URLをコピーしました"
      />
    </>
  );
};

export default ListShareMenu; 